export function hasAnyOfRequiredPermission(requiredPermissions, loginInfo) {
  if (
    !loginInfo ||
    !loginInfo.role ||
    !loginInfo.role.permissionList ||
    loginInfo.role.permissionList.length == 0 ||
    !requiredPermissions
  ) {
    return false;
  }

  const userPermissions = loginInfo.role.permissionList;

  // 必要なパーミッションのいずれかがユーザーのパーミッションリストに含まれているかをチェック
  // requiredPermissionsは文字列の配列を想定 (例: ["DASHBOARD:READ", "DASHBOARD:COMPANY_SELECT"])
  return requiredPermissions.some(requiredPermission => {
    const [featureType, permissionType] = requiredPermission.split(':');
    return userPermissions.some(userPermission =>
      userPermission.featureType === featureType &&
      userPermission.permissionType === permissionType
    )
  })
}

export function hasAllRequiredPermission(requiredPermissions, loginInfo) {
  if (
    !loginInfo ||
    !loginInfo.role ||
    !loginInfo.role.permissionList ||
    loginInfo.role.permissionList.length == 0 ||
    !requiredPermissions
  ) {
    return false;
  }

  const userPermissions = loginInfo.role.permissionList;

  // 必要な全てのパーミッションのユーザーのパーミッションリストに含まれているかをチェック
  // requiredPermissionsは文字列の配列を想定 (例: ["DASHBOARD:READ", "DASHBOARD:COMPANY_SELECT"])
  return requiredPermissions.every(requiredPermission => {
    const [featureType, permissionType] = requiredPermission.split(':');
    return userPermissions.some(userPermission =>
      userPermission.featureType === featureType &&
      userPermission.permissionType === permissionType
    )
  })
}
